import HamburgerCloseButtonComponent from '../components/HamburgerMenu/HamburgerCloseButton/viewer/HamburgerCloseButton';
import HamburgerCloseButtonController from '../components/HamburgerMenu/HamburgerCloseButton/viewer/HamburgerCloseButton.controller';
import HamburgerCloseButton_DefaultComponent from '../components/HamburgerMenu/HamburgerCloseButton/viewer/skinComps/Default/Default.skin';
import HamburgerCloseButton_HamburgerCloseButtonComponent from '../components/HamburgerMenu/HamburgerCloseButton/viewer/skinComps/HamburgerCloseButton/HamburgerCloseButton.skin';
import HamburgerMenuContainerComponent from '../components/HamburgerMenu/HamburgerMenuContainer/viewer/HamburgerMenuContainer';
import HamburgerMenuContainerController from '../.components/HamburgerMenu/HamburgerMenuContainer/viewer/HamburgerMenuContainer.controller';
import HamburgerMenuContainer_DefaultComponent from '../components/HamburgerMenu/HamburgerMenuContainer/viewer/skinComps/Default/Default.skin';
import HamburgerMenuContainer_HamburgerMenuContainerComponent from '../components/HamburgerMenu/HamburgerMenuContainer/viewer/skinComps/HamburgerMenuContainer/HamburgerMenuContainer.skin';
import HamburgerMenuContentComponent from '../components/HamburgerMenu/HamburgerMenuContent/viewer/HamburgerMenuContent';
import HamburgerMenuRootComponent from '../components/HamburgerMenu/HamburgerMenuRoot/viewer/HamburgerMenuRoot';
import HamburgerMenuRootController from '../.components/HamburgerMenu/HamburgerMenuRoot/viewer/HamburgerMenuRoot.controller';
import HamburgerOpenButtonComponent from '../components/HamburgerMenu/HamburgerOpenButton/viewer/HamburgerOpenButton';
import HamburgerOpenButtonController from '../components/HamburgerMenu/HamburgerOpenButton/viewer/HamburgerOpenButton.controller';
import HamburgerOpenButton_DefaultComponent from '../components/HamburgerMenu/HamburgerOpenButton/viewer/skinComps/Default/Default.skin';
import HamburgerOpenButton_HamburgerOpenButtonComponent from '../components/HamburgerMenu/HamburgerOpenButton/viewer/skinComps/HamburgerOpenButton/HamburgerOpenButton.skin';
import HamburgerOverlayComponent from '../components/HamburgerMenu/HamburgerOverlay/viewer/HamburgerOverlay';
import HamburgerOverlayController from '../components/HamburgerMenu/HamburgerOverlay/viewer/HamburgerOverlay.controller';
import HamburgerOverlay_DefaultComponent from '../components/HamburgerMenu/HamburgerOverlay/viewer/skinComps/Default/Default.skin';
import HamburgerOverlay_HamburgerOverlayComponent from '../components/HamburgerMenu/HamburgerOverlay/viewer/skinComps/HamburgerOverlay/HamburgerOverlay.skin';
import MegaMenuContainerItem_ClassicComponent from '../components/MegaMenuContainerItem/viewer/skinComps/Classic/Classic.skin';
import MegaMenuContainerItem_DropdownComponent from '../components/MegaMenuContainerItem/viewer/skinComps/Dropdown/Dropdown.skin';
import MegaMenuContainerItem_ResponsiveComponent from '../components/MegaMenuContainerItem/viewer/skinComps/Responsive/Responsive.skin';
import MenuContentComponent from '../components/Menu/MenuContent/viewer/MenuContent';
import MenuComponent from '../components/Menu/viewer/Menu';
import MenuController from '../components/Menu/viewer/Menu.controller';
import StylableHorizontalMenu_DefaultComponent from '../components/StylableHorizontalMenu/viewer/skinComps/Default/Default.skin';
import StylableHorizontalMenu_DefaultController from '../components/StylableHorizontalMenu/viewer/StylableHorizontalMenu.controller';
import StylableHorizontalMenu_ScrollColumnComponent from '../components/StylableHorizontalMenu/viewer/skinComps/ScrollColumn/ScrollColumn.skin';
import StylableHorizontalMenu_ScrollFlyoutComponent from '../components/StylableHorizontalMenu/viewer/skinComps/ScrollFlyout/ScrollFlyout.skin';
import StylableHorizontalMenu_ScrollFlyoutAndColumnComponent from '../components/StylableHorizontalMenu/viewer/skinComps/ScrollFlyoutAndColumn/ScrollFlyoutAndColumn.skin';
import StylableHorizontalMenu_WrapColumnComponent from '../components/StylableHorizontalMenu/viewer/skinComps/WrapColumn/WrapColumn.skin';
import StylableHorizontalMenu_WrapFlyoutComponent from '../components/StylableHorizontalMenu/viewer/skinComps/WrapFlyout/WrapFlyout.skin';
import StylableHorizontalMenu_WrapFlyoutAndColumnComponent from '../components/StylableHorizontalMenu/viewer/skinComps/WrapFlyoutAndColumn/WrapFlyoutAndColumn.skin';
import StylableHorizontalMenuComponent from '../components/StylableHorizontalMenu/viewer/StylableHorizontalMenu';
import SubmenuComponent from '../components/Submenu/viewer/Submenu';


const HamburgerCloseButton = {
  component: HamburgerCloseButtonComponent,
  controller: HamburgerCloseButtonController
};

const HamburgerCloseButton_Default = {
  component: HamburgerCloseButton_DefaultComponent,
  controller: HamburgerCloseButtonController
};

const HamburgerCloseButton_HamburgerCloseButton = {
  component: HamburgerCloseButton_HamburgerCloseButtonComponent,
  controller: HamburgerCloseButtonController
};

const HamburgerMenuContainer = {
  component: HamburgerMenuContainerComponent,
  controller: HamburgerMenuContainerController
};

const HamburgerMenuContainer_Default = {
  component: HamburgerMenuContainer_DefaultComponent,
  controller: HamburgerMenuContainerController
};

const HamburgerMenuContainer_HamburgerMenuContainer = {
  component: HamburgerMenuContainer_HamburgerMenuContainerComponent,
  controller: HamburgerMenuContainerController
};

const HamburgerMenuContent = {
  component: HamburgerMenuContentComponent
};

const HamburgerMenuRoot = {
  component: HamburgerMenuRootComponent,
  controller: HamburgerMenuRootController
};

const HamburgerOpenButton = {
  component: HamburgerOpenButtonComponent,
  controller: HamburgerOpenButtonController
};

const HamburgerOpenButton_Default = {
  component: HamburgerOpenButton_DefaultComponent,
  controller: HamburgerOpenButtonController
};

const HamburgerOpenButton_HamburgerOpenButton = {
  component: HamburgerOpenButton_HamburgerOpenButtonComponent,
  controller: HamburgerOpenButtonController
};

const HamburgerOverlay = {
  component: HamburgerOverlayComponent,
  controller: HamburgerOverlayController
};

const HamburgerOverlay_Default = {
  component: HamburgerOverlay_DefaultComponent,
  controller: HamburgerOverlayController
};

const HamburgerOverlay_HamburgerOverlay = {
  component: HamburgerOverlay_HamburgerOverlayComponent,
  controller: HamburgerOverlayController
};

const MegaMenuContainerItem_Classic = {
  component: MegaMenuContainerItem_ClassicComponent
};

const MegaMenuContainerItem_Dropdown = {
  component: MegaMenuContainerItem_DropdownComponent
};

const MegaMenuContainerItem_Responsive = {
  component: MegaMenuContainerItem_ResponsiveComponent
};

const MenuContent = {
  component: MenuContentComponent
};

const Menu = {
  component: MenuComponent,
  controller: MenuController
};

const StylableHorizontalMenu_Default = {
  component: StylableHorizontalMenu_DefaultComponent,
  controller: StylableHorizontalMenu_DefaultController
};

const StylableHorizontalMenu_ScrollColumn = {
  component: StylableHorizontalMenu_ScrollColumnComponent,
  controller: StylableHorizontalMenu_DefaultController
};

const StylableHorizontalMenu_ScrollFlyout = {
  component: StylableHorizontalMenu_ScrollFlyoutComponent,
  controller: StylableHorizontalMenu_DefaultController
};

const StylableHorizontalMenu_ScrollFlyoutAndColumn = {
  component: StylableHorizontalMenu_ScrollFlyoutAndColumnComponent,
  controller: StylableHorizontalMenu_DefaultController
};

const StylableHorizontalMenu_WrapColumn = {
  component: StylableHorizontalMenu_WrapColumnComponent,
  controller: StylableHorizontalMenu_DefaultController
};

const StylableHorizontalMenu_WrapFlyout = {
  component: StylableHorizontalMenu_WrapFlyoutComponent,
  controller: StylableHorizontalMenu_DefaultController
};

const StylableHorizontalMenu_WrapFlyoutAndColumn = {
  component: StylableHorizontalMenu_WrapFlyoutAndColumnComponent,
  controller: StylableHorizontalMenu_DefaultController
};

const StylableHorizontalMenu = {
  component: StylableHorizontalMenuComponent,
  controller: StylableHorizontalMenu_DefaultController
};

const Submenu = {
  component: SubmenuComponent
};


export const components = {
  ['HamburgerCloseButton']: HamburgerCloseButton,
  ['HamburgerCloseButton_Default']: HamburgerCloseButton_Default,
  ['HamburgerCloseButton_HamburgerCloseButton']: HamburgerCloseButton_HamburgerCloseButton,
  ['HamburgerMenuContainer']: HamburgerMenuContainer,
  ['HamburgerMenuContainer_Default']: HamburgerMenuContainer_Default,
  ['HamburgerMenuContainer_HamburgerMenuContainer']: HamburgerMenuContainer_HamburgerMenuContainer,
  ['HamburgerMenuContent']: HamburgerMenuContent,
  ['HamburgerMenuRoot']: HamburgerMenuRoot,
  ['HamburgerOpenButton']: HamburgerOpenButton,
  ['HamburgerOpenButton_Default']: HamburgerOpenButton_Default,
  ['HamburgerOpenButton_HamburgerOpenButton']: HamburgerOpenButton_HamburgerOpenButton,
  ['HamburgerOverlay']: HamburgerOverlay,
  ['HamburgerOverlay_Default']: HamburgerOverlay_Default,
  ['HamburgerOverlay_HamburgerOverlay']: HamburgerOverlay_HamburgerOverlay,
  ['MegaMenuContainerItem_Classic']: MegaMenuContainerItem_Classic,
  ['MegaMenuContainerItem_Dropdown']: MegaMenuContainerItem_Dropdown,
  ['MegaMenuContainerItem_Responsive']: MegaMenuContainerItem_Responsive,
  ['MenuContent']: MenuContent,
  ['Menu']: Menu,
  ['StylableHorizontalMenu_Default']: StylableHorizontalMenu_Default,
  ['StylableHorizontalMenu_ScrollColumn']: StylableHorizontalMenu_ScrollColumn,
  ['StylableHorizontalMenu_ScrollFlyout']: StylableHorizontalMenu_ScrollFlyout,
  ['StylableHorizontalMenu_ScrollFlyoutAndColumn']: StylableHorizontalMenu_ScrollFlyoutAndColumn,
  ['StylableHorizontalMenu_WrapColumn']: StylableHorizontalMenu_WrapColumn,
  ['StylableHorizontalMenu_WrapFlyout']: StylableHorizontalMenu_WrapFlyout,
  ['StylableHorizontalMenu_WrapFlyoutAndColumn']: StylableHorizontalMenu_WrapFlyoutAndColumn,
  ['StylableHorizontalMenu']: StylableHorizontalMenu,
  ['Submenu']: Submenu
};

